<template>
<div class="comfirmed-section">
    <img src="/images/icons/check.svg" alt="check">
    <h3 class="text-primary text-center mt-12">{{ $t('wizard.comfirm_title') }}</h3>
    <h6 class="text-primary text-center mt-6">{{ $t('wizard.comfirm_text') }}</h6>
    <p class="text-center mt-3">{{ $t('wizard.warning_text') }}</p>

</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.comfirmed-section{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 50px 0;
    
    p {
        font-size: 1rem;
        color: $rouge;
    }
}

</style>